const paletteColors = {
  red: {
    100: "#FCF2F5",
    200: "#EAE0E3",
    300: "#DF546D",
    400: "#A81D42",
    500: "#73001C",
    gradient: ["#A81D42", "#DF546D"]
  },
  blue: {
    100: "#EEF5F8",
    200: "#DEE9ED",
    300: "#60D2E9",
    400: "#19A1B7",
    500: "#007287",
    gradient: ["#014550", "#007287"]
  },
  grey: {
    100: "#FAFAFA",
    200: "#F3F4F6",
    300: "#E2E5EB",
    400: "#C7CDD6",
    500: "#999FAB",
    600: "#858D9C",
    700: "#6B7280",
    800: "#4B5563",
    900: "#374151"
  },
  error: {
    100: "#F4E3E6",
    200: "#EA3D5C"
  },
  success: {
    100: "#DDEFEE",
    200: "#05B7AC"
  },
  warning: {
    100: "#F6EFE0",
    200: "#FAB41C"
  },
  info: "#0E75BF",
  focus: "#FF47F8"
}, paletteColorsV3 = {
  primary: {
    100: "#FDF7F9",
    200: "#F9EFF2",
    300: "#F3DFE5",
    400: "#F4C3CC",
    500: "#F0A6BA",
    600: "#E87A97",
    700: "#E46386",
    800: "#DF546D",
    900: "#A81D42",
    1e3: "#73001C"
  },
  secondary: {
    100: "#F7FCFD",
    200: "#EFF8FA",
    300: "#DFF2F5",
    400: "#CFEBF0",
    500: "#BFE5EB",
    600: "#94D1DB",
    700: "#6EC4D2",
    800: "#60D2E9",
    900: "#19A1B7",
    1e3: "#007287"
  },
  grey: {
    100: "#FAFAFA",
    200: "#F3F4F6",
    300: "#E2E5EB",
    400: "#C7CDD6",
    500: "#999FAB",
    600: "#858D9C",
    700: "#6B7280",
    800: "#4B5563",
    900: "#374151",
    1e3: "#171B22"
  },
  radicalRed: {
    100: "#FFF6F7",
    200: "#FDECEF",
    300: "#FBD8DE",
    400: "#F9C5CE",
    500: "#F49EAE",
    600: "#F28B9E",
    700: "#F17E92",
    800: "#EE5D77",
    900: "#EA3D5C",
    1e3: "#C81636"
  },
  sunnyYellow: {
    100: "#FFFBF2",
    200: "#FEF7E8",
    300: "#FEF0D2",
    400: "#F7E3B9",
    500: "#FDE0A0",
    600: "#FDDA8E",
    700: "#FCCD68",
    800: "#FBC142",
    900: "#FAB41C",
    1e3: "#CC8D04"
  },
  tiffanyBlue: {
    100: "#EEFAFA",
    200: "#E6F8F7",
    300: "#CDF1EE",
    400: "#A2E1DC",
    500: "#89DCD8",
    600: "#55DBD2",
    700: "#3ED1C8",
    800: "#13CCC1",
    900: "#05B7AC",
    1e3: "#04998F"
  },
  blueGreen: {
    100: "#F5FAFE",
    200: "#E7F1F9",
    300: "#B8DEFA",
    400: "#A0D3F8",
    500: "#7EB7E1",
    600: "#59B3F3",
    700: "#2A9DEF",
    800: "#1084D7",
    900: "#0E75BF",
    1e3: "#0C629F"
  },
  ube: {
    100: "#FAF8FF",
    200: "#F2EEFB",
    300: "#E6E2F4",
    400: "#CCC2E8",
    500: "#C2B6E4",
    600: "#B7A9DF",
    700: "#AD9DDA",
    800: "#9985D1",
    900: "#846CC8",
    1e3: "#6955A1"
  },
  gamboge: {
    100: "#FFFAF5",
    200: "#FFF2E7",
    300: "#FFE6CF",
    400: "#FFCB9B",
    500: "#FFB672",
    600: "#FFA95A",
    700: "#FFA14A",
    800: "#FF8C22",
    900: "#FF810E",
    1e3: "#E06B00"
  },
  mountbattenPink: {
    100: "#F9F8F8",
    200: "#F5F2F4",
    300: "#EBE4E8",
    400: "#D5C8D0",
    500: "#C4B1BD",
    600: "#BBA6B3",
    700: "#B39BAA",
    800: "#AA90A0",
    900: "#997A8D",
    1e3: "#755A6A"
  },
  white: "#FFFFFF"
};
export {
  paletteColors,
  paletteColorsV3
};
//# sourceMappingURL=vivicaUiKitColors.js.map
